export default "/images/302d66835221dd2e4ea694c454a8ea81.jpg";